module.exports = __webpack_public_path__ + "img/aqualink.421b2bc7.svg";